export default __webpack_public_path__ + "static/media/PrivacyPolicy-DE.dc1dcbf2.pdf";